<template>
    <v-card>
        딸 1
    </v-card>
</template>
<script>
export default {
    
}
</script>